var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.88885 1V4.11111M12.5555 1V4.11111M17.2222 1V4.11111M14.1111 10.3333H7.88885M17.2222 16.5556H7.88885M6.6444 29H18.4666C20.209 29 21.0803 29 21.7457 28.6609C22.3311 28.3627 22.8071 27.8867 23.1053 27.3013C23.4444 26.6359 23.4444 25.7646 23.4444 24.0222V7.53333C23.4444 5.79096 23.4444 4.91975 23.1053 4.25425C22.8071 3.66885 22.3311 3.19291 21.7457 2.89465C21.0803 2.55556 20.209 2.55556 18.4666 2.55556H6.6444C4.90203 2.55556 4.03082 2.55556 3.36532 2.89465C2.77992 3.19291 2.30398 3.66885 2.00572 4.25425C1.66663 4.91975 1.66663 5.79094 1.66663 7.53333V24.0222C1.66663 25.7646 1.66663 26.6359 2.00572 27.3013C2.30398 27.8867 2.77992 28.3627 3.36532 28.6609C4.03082 29 4.90201 29 6.6444 29Z",
    stroke: "#8D90A5",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.08a350640aacfae9a231bdbba22db15a.svg";
export { ForwardRef as ReactComponent };